import React, { useEffect, useRef, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { useIsDesktop } from '../../../Utils/productPageUtils';
import { IVFCarouselCSS } from '../../IVF/IVFCarousel/styled';
import {
  CarouselContainer,
  ImageOuter,
  TextContainer,
  TextContainerOuter,
} from './styled';

function CarouselNew(props) {
  const { testimonialData, newReviews } = props;
  const carousel = useRef();
  const [selectedItem, setSelectedItem] = useState();
  const isDesktop = useIsDesktop();
  useEffect(() => {
    setSelectedItem(carousel?.current?.state?.selectedItem);
  }, [carousel?.current?.state?.selectedItem]);
  const data = testimonialData || [
    {
      image:
        'https://images.myloapp.in/NestJsUploads/1697899939010-testimonial-image-–-1_ANITA.webp',

      heading: 'Anita, Mom of 1 year old baby',
      subHeading:
        'I would recommend Mylo’s Stretch Marks Kit to every pregnant & new mom! It actually works. Faded my stretch marks visibly in just 28 Days. I can wear my favourite sarees and dresses again...I feel so good!',
    },
    {
      image:
        'https://images.myloapp.in/NestJsUploads/1697898375450-testimonial-image-–-2_TULIKA.webp',

      heading: 'TULIKA, Mom of a 6 month old baby',
      subHeading:
        'I want only the best for my baby! Which is why I trust only Mylo products for my little one! I am a big fan of their Printed Cloth Diapers...keeps my baby’s bums dry and they are soo cute and colourful to look at!',
    },
    {
      image:
        'https://images.myloapp.in/NestJsUploads/1697899939012-testimonial-image-–-3_PRAGYA.webp',

      heading: 'Pragya, Mom of 2 year old',
      subHeading:
        'Mylo is literally helping me Raise Happiness! My baby’s skin is clearer, softer, irritation-free and he looks forward to his massage and bath time with Mylo’s products!',
    },
    {
      image:
        'https://images.myloapp.in/NestJsUploads/1697899939012-testimonial-image-–-4_kritika.webp',

      heading: 'KRITIKA, 8 months pregnant',
      subHeading:
        'When I found out I was pregnant, I was so overwhelmed. Because I didn’t have a single clue on how to be the perfect mom or even a good mom. But then I found Mylo and it was like finding a comfort friend I could ask the stupidest doubts from and share my worries with and never be judged in the process',
    },
  ];
  return (
    <CarouselContainer newReviews={newReviews} className="container">
      <IVFCarouselCSS color={'transparent'}>
        <div className="headingSection">
          <h3 className="heading">TESTIMONIALS</h3>
          <p className="description-our-philosophy">Mothers know the best</p>
        </div>
        <Carousel
          ref={carousel}
          infiniteLoop
          centerMode={isDesktop}
          centerSlidePercentage={25}
          showArrows={false}
          showStatus={false}
          interval={2000}
          showThumbs={false}
          preventMovementUntilSwipeScrollTolerance
          onChange={(currentIndex, item) => {
            setSelectedItem(currentIndex);
          }}
          autoPlay={!newReviews}
        >
          {data?.map((element, index) => {
            return (
              <ImageOuter
                onClick={(e) => e.stopPropagation()}
                selectedItem={selectedItem}
                className={
                  index < selectedItem
                    ? 'rotateAntiClock'
                    : index > selectedItem
                      ? 'rotateClock'
                      : ''
                }
                key={`car_${index}`}
              >
                <div
                  style={{
                    width: '50%',
                  }}
                  className="imageContainer"
                >
                  <img src={element.image} alt="" />
                </div>
              </ImageOuter>
            );
          })}
        </Carousel>
        <TextContainerOuter>
          <TextContainer>
            <p className="name">{data?.[selectedItem]?.heading}</p>
            <p className="desc">{data?.[selectedItem]?.subHeading}</p>
          </TextContainer>
        </TextContainerOuter>
      </IVFCarouselCSS>
    </CarouselContainer>
  );
}

export default CarouselNew;
